document.addEventListener('DOMContentLoaded', function() {
  const gallery = document.querySelector('.custom-product__media');
  if (!gallery) return;
  
  const items = gallery.querySelectorAll('.custom-product__media-img');
  const btn = document.getElementById('GalleryMoreBtn');
  
  items.forEach((item, index) => {
    if (index >= 2) item.classList.add('hidden-media');
  });
  
  if (btn) {
    btn.addEventListener('click', function() {
      items.forEach(item => item.classList.remove('hidden-media'));
      btn.style.display = 'none'; 
    });
  }
});